import React from "react";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";
import ChangeIcon from "../Icons/ChangeIcon";

export default function ChangeButton(props) {
  return (
    <Button
      color={props.color}
      variant="text"
      size="small"
      onClick={props.onClick}
      startIcon={
        <Box display="flex" mr={-0.75}>
          <ChangeIcon color={props.color} />
        </Box>
      }
    >
      {props.text}
    </Button>
  );
}

ChangeButton.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

ChangeButton.defaultProps = {
  color: "primary"
};
